import { Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function ContactLink({ language, children }) {
  return (
    <Button
      component="a"
      href="/kontakt"
      variant="contained"
      endIcon={<ArrowForwardIcon />}
      sx={{
        mt: 2,
        px: 2.5,
        py: 0.8,
        borderRadius: "7px",
        backgroundColor: "#334f75",
        color: "#fff",
        fontWeight: 500,
        textTransform: "none",
        fontSize: "14px",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#243e60",
          boxShadow: "0 3px 8px rgba(30, 58, 95, 0.15)",
        },
      }}
    >
      {children || (language === "pl" ? "Porozmawiajmy" : "Let's talk")}
    </Button>
  );
}
